import React from 'react';
import '../../styles/SkeletonLoader.css';

interface SkeletonLoaderProps {
    lines: number; // Number of lines for the skeleton
    circles: number; // Number of circular skeletons
    width?: string; // Width of the skeleton lines or circles
    height?: string; // Height of each skeleton line or circle
    circleSize?: string; // Diameter of the circular skeletons
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
    lines,
    circles,
    width = '100%',
    height = '20px',
    circleSize = '50px',
}) => {
    const skeletonLines = Array.from({ length: lines }, (_, index) => index);
    const skeletonCircles = Array.from({ length: circles }, (_, index) => index);

    return (
        <div className="skeleton-loader">
            {/* Circle Skeletons */}
            {skeletonCircles.map((circle, index) => (
                <div
                    key={index}
                    className="skeleton-circle"
                    style={{ width: circleSize, height: circleSize }}
                ></div>
            ))}

            {/* Line Skeletons */}
            {skeletonLines.map((line, index) => (
                <div
                    key={index}
                    className="skeleton-line"
                    style={{ width, height }}
                ></div>
            ))}
        </div>
    );
};

export default SkeletonLoader;
